const isInQuan = (timeQuan, timeArr) => {
    if (timeArr.length == 0) return true
    let isarr = []
    for (let i in timeArr) {
        isarr.push(timeQuan[0].replace('-', '') > timeArr[i][1].replace('-', '') || timeQuan[1].replace('-', '') < timeArr[i][0].replace('-', ''))

    }
    if (isarr.indexOf(false) == -1) {
        return true
    }
    return false
}
export default isInQuan


// WEBPACK FOOTER //
// ./src/utils/isInQuan.js